import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import Currency from "src/react/components/currency";
import { TrackedRouterLink } from "src/react/components/link";

export const PRODUCT_CARD_SIZES = {
  SMALL: "small",
  DEFAULT: "default",
};

// TODO: add unit tests
export function Product({
  children,
  product,
  size = PRODUCT_CARD_SIZES.DEFAULT,
  priceNote,
}) {
  return (
    <ProductWrapper {...(product.slug && { id: product.slug })}>
      <TrackedRouterLink
        to={product.link}
        css={imageLinkStyles}
        title={`Read more about ${product.name}`}
      >
        <LazyLoad once height={220} offset={50}>
          <ProductImage
            width="220"
            height="220"
            src={`${product.image}&w=220`}
            srcSet={`${product.image}&w=440 2x`}
            alt={product.name || ""}
            size={size}
          />
        </LazyLoad>
      </TrackedRouterLink>
      <ProductHeader>
        <ProductTitle size={size}>{product.name}</ProductTitle>
        <ProductPrice size={size}>
          <Currency value={product.priceInPence} />
          {priceNote ? "*" : ""}
          {priceNote && <PriceNote>*{priceNote}</PriceNote>}
        </ProductPrice>
      </ProductHeader>
      {children}
    </ProductWrapper>
  );
}

Product.propTypes = {
  children: PropTypes.any,
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    priceInPence: PropTypes.number.isRequired,
    link: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    description: PropTypes.string,
    slug: PropTypes.string,
  }).isRequired,
  size: PropTypes.oneOf(Object.values(PRODUCT_CARD_SIZES)),
  priceNote: PropTypes.string,
};

export default Product;

const ProductWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ProductImage = styled.img`
  max-height: 220px;
  height: auto;
`;

const ProductHeader = styled.header`
  flex-grow: 1;
  flex-shrink: 1;
`;

const ProductTitle = styled.h3`
  font-size: ${({ size }) =>
    size === PRODUCT_CARD_SIZES.SMALL ? `14px` : `16px`};
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: 5px;
  @media (min-width: 600px) {
    font-size: ${({ size }) => size !== PRODUCT_CARD_SIZES.SMALL && "20px"};
  }
`;

const ProductPrice = styled.p`
  font-size: ${({ size }) =>
    size === PRODUCT_CARD_SIZES.SMALL ? `18px` : `26px`};
  ${({ size }) => size === PRODUCT_CARD_SIZES.SMALL && `margin-bottom: 10px;`}
`;

const PriceNote = styled.span`
  display: block;
  font-size: 14px;
`;

const imageLinkStyles = `
  display: block;
  align-self: center;
  margin-bottom: 10px;
`;
